import { render, staticRenderFns } from "./BlindDetails.vue?vue&type=template&id=b15eb40e&"
import script from "./BlindDetails.vue?vue&type=script&lang=ts&"
export * from "./BlindDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports